import { isAnnouncementStyleName, type AnnouncementStyleName } from '@org/ui';

export { isAnnouncementStyleName };
export type { AnnouncementStyleName };

/**
 * Which look the student announcement ("Comunicado") pop-up uses.
 *
 * The cards themselves live in `@org/ui` (`ANNOUNCEMENT_STYLE_CARDS`) so the
 * admin can preview them. Resolution order, first match wins:
 *
 *   1. `?announcementStyle=<name>` on the page URL (previews on dev);
 *   2. the style the admin chose for that announcement (`announcement.style`);
 *   3. `ANNOUNCEMENT_STYLE` below — what announcements without a choice get.
 */
export const ANNOUNCEMENT_STYLE: AnnouncementStyleName = 'classic';

export const ANNOUNCEMENT_STYLE_QUERY_PARAM = 'announcementStyle';

export function resolveAnnouncementStyle(
  search?: string,
  announcementStyle?: string | null,
): AnnouncementStyleName {
  const raw = search ?? (typeof window !== 'undefined' ? window.location.search : '');
  const override = new URLSearchParams(raw).get(ANNOUNCEMENT_STYLE_QUERY_PARAM);
  if (isAnnouncementStyleName(override)) return override;
  if (isAnnouncementStyleName(announcementStyle)) return announcementStyle;
  return ANNOUNCEMENT_STYLE;
}
